// extracted by mini-css-extract-plugin
export default {"root":"popup_root__AmFQU","opened":"popup_opened__bGcfW","container":"popup_container__8kesV"};